import { render, staticRenderFns } from "./Offerte.vue?vue&type=template&id=513d3f95&scoped=true"
import script from "./Offerte.vue?vue&type=script&lang=js"
export * from "./Offerte.vue?vue&type=script&lang=js"
import style0 from "./Offerte.vue?vue&type=style&index=0&id=513d3f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d3f95",
  null
  
)

export default component.exports